export const namespaced = true

export const state = {
  notifications: []
}

let nextId = 1

export const mutations = {
  PUSH(state, notification) {
    const checkExists = state.notifications.filter(function (item) {
      return item.id === notification.id
    }).length

    if (typeof notification.id !== 'undefined' && checkExists) {
      return
    }
    state.notifications.push({
      ...notification,
      id: notification.id || nextId++
    })
  },
  DELETE(state, notificationToRemove) {
    state.notifications = state.notifications.filter(notification => notification.id !== notificationToRemove.id)
  }
}

export const getters = {
  getNotificationsByKind: state => kind => {
    return state.notifications ? state.notifications.filter(notification => notification.kind === kind) : false
  }
}

export const actions = {
  add({ commit }, notification) {
    commit('PUSH', notification)
    window.dispatchEvent(new Event('resize'))
  },
  remove({ commit }, notificationToRemove) {
    commit('DELETE', notificationToRemove)
  }
}
